export default function Maps_Events() {
  return (
    <div>
      <h1>Maps_Events Component</h1>
    </div>
  );
}
